// import React from 'react';
// import style from "./index.module.css";
// import {Breadcrumb, Divider} from "antd";
// import CertificateNavModule from "../../components/certificateNavModule";
// import noDataIcon from "../../assets/icons/noData.svg";
//
// const FifthPage = () => {
//     const baseItem = [
//         {
//             title: <div>首页</div>,
//         },
//         {
//             title: "证书管理",
//         },
//     ];
//
//     return (
//         <div className={style.pageContainer}>
//             <Breadcrumb
//                 items={baseItem}
//             />
//
//             <div className={style.content}>
//                 <div className={style.leftNavBar}>
//                     <CertificateNavModule/>
//                 </div>
//
//                 <div className={style.rightMainContainer}>
//                     <div>
//                         <div className={style.pageTitle}>证书管理</div>
//                         <Divider style={{padding: '0 30px', borderColor: '#043554'}}>CERTIFICATE MANAGEMENT</Divider>
//                     </div>
//
//                     <div style={{display: "grid", placeItems: 'center'}}>
//                         <img src={noDataIcon} height={200} width={300} alt=""/>
//                         <div>暂无内容</div>
//                     </div>
//
//                 </div>
//             </div>
//
//         </div>
//
//     );
// };
//
// export default FifthPage;


import React, { useState } from 'react';
import style from "./index.module.css";
import { Breadcrumb, Divider } from "antd";
import CertificateNavModule from "../../components/certificateNavModule";
// import CertificateNavModule from "../../components/certificateNavModule"; // 暂时注释，因为我们需要自定义左侧导航
// import noDataIcon from "../../assets/icons/noData.svg"; // 不再需要

const FifthPage = () => {
    // 定义当前选中的锚点，默认选中第一个
    const [activeSection, setActiveSection] = useState('section1');

    const baseItem = [
        { title: <div>首页</div> },
        { title: "证书管理" },
    ];

    // 导航配置
    const navItems = [
        { id: 'section1', label: '证书保持' },
        { id: 'section2', label: '证书扩大/缩小' },
        { id: 'section3', label: '证书变更' },
        { id: 'section4', label: '证书暂停' },
        { id: 'section5', label: '恢复' },
        { id: 'section6', label: '证书撤销' },
        { id: 'section7', label: '证书注销' },
    ];

    // 点击导航滚动到对应位置
    const scrollToSection = (id:any) => {
        setActiveSection(id);
        const element = document.getElementById(id);
        if (element) {
            // 减去一些头部偏移量，避免标题被遮挡
            const headerOffset = 20;
            const elementPosition = element.getBoundingClientRect().top;
            const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

            // 如果是在容器内滚动，使用 scrollIntoView 更简单
            element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    };

    // 文本段落样式
    const paragraphStyle = { marginBottom: '15px', lineHeight: '1.8', textIndent: '2em' };
    const listStyle = { marginBottom: '15px', lineHeight: '1.8', paddingLeft: '20px' };
    const subTitleStyle = { fontSize: '18px', fontWeight: 'bold', color: '#333', marginTop: '30px', marginBottom: '15px', borderLeft: '4px solid #00a2e9', paddingLeft: '10px' };

    return (
        <div className={style.pageContainer}>
            <Breadcrumb items={baseItem} />

            <div className={style.content}>
                {/* 左侧导航栏 - 替换原有的组件，改为锚点控制 */}
                <div className={style.leftNavBar}>
                    {navItems.map((item) => (
                        <button
                            key={item.id}
                            className={activeSection === item.id ? style.leftNavBarBtnPushed : style.leftNavBarBtn}
                            onClick={() => scrollToSection(item.id)}
                        >
                            {item.label}
                        </button>
                    ))}

                    <div style={{height:60}}/>
                    <CertificateNavModule />
                </div>

                <div className={style.rightMainContainer}>
                    <div>
                        <div className={style.pageTitle}>证书管理</div>
                        <Divider style={{ padding: '0 30px', borderColor: '#043554' }}>CERTIFICATE MANAGEMENT</Divider>
                    </div>

                    {/* 文章内容区域 */}
                    <div className={style.articleContainer} style={{ height: '700px', overflowY: 'auto', scrollBehavior: 'smooth' }}>

                        {/* 一 证书保持 */}
                        <div id="section1">
                            <div style={subTitleStyle}>一、 证书保持</div>
                            <p style={paragraphStyle}>
                                公司在监督审核中，对获证组织的产品按标准运行是否持续符合标准要求进行审核，确认证书的有效性。若获证组织基本符合标准要求，则公司保持其认证注册资格。
                            </p>
                        </div>

                        {/* 二 证书扩大/缩小 */}
                        <div id="section2">
                            <div style={subTitleStyle}>二、 证书扩大/缩小</div>
                            <div style={listStyle}>
                                <p>（一）对于获证组织扩大产品范围或原认证依据标准的内容扩大，应经申请认证评审员评审受理后，审查部安排审核，经公司认证评定批准，技术评审部发出《认证结果通知书》，换发证书。</p>
                                <p>（二）对于获证组织缩小产品范围或原认证依据标准的内容缩小，审核组现场确认后，经技术评审部评定批准后，发出《认证结果通知书》，换发证书。</p>
                                <p>（三）如果客户在认证范围的某些部分持续地或严重地不满足认证要求，审核组现场确认后，经技术评审部评定批准后，缩小其认证范围（范围的缩小应与相应的认证标准要求一致），发出《认证结果通知书》，换发证书。</p>
                            </div>
                        </div>

                        {/* 三 证书变更 */}
                        <div id="section3">
                            <div style={subTitleStyle}>三、 证书变更</div>
                            <p>有下列情况之一：</p>
                            <div style={listStyle}>
                                <p>（一）获证组织申请认证依据标准和/或体系覆盖产品扩大/缩小时；</p>
                                <p>（二）认证依据标准和认证要求发生变更时；</p>
                                <p>（三）仅为获证组织名称变更；</p>
                                <p>（四）法律地位、经营状况、组织状态或所有权发生变更；</p>
                                <p>（五）组织和管理层（如关键的管理、决策或技术人员）发生变更；</p>
                                <p>（六）引起认证证书内容变更的其它情况。</p>
                            </div>
                            <p style={paragraphStyle}>
                                对于（一）、（二）、（四）、（五）、（六）类情况，由技术评审部按《认证实施工作程序》有关要求，根据实际情况决定是否对获证组织进行审核，技术评审部依据认证结果按第五条和/或第十一条款执行；对于（三）类情况，应由获证组织提交书面申请及有关证实材料（如营业执照复印件、名称变更核准通知书、更名后的资质证书等），由认证申请评审员进行评审，如受理则由技术评审部验证符合要求后，按第六条要求换发证书。
                            </p>
                        </div>

                        {/* 四 证书暂停 */}
                        <div id="section4">
                            <div style={subTitleStyle}>四、 证书暂停</div>
                            <p>有下列情况之一：</p>
                            <div style={listStyle}>
                                <p>（一）获证组织对其产品运行体系进行了修改，且该修改影响到认证资格的保持，但未通报公司；</p>
                                <p>（二）监督审核发现获证组织管理体系存在不符合项，且在规定的时限内不能采取有效纠正措施，且严重程度尚不构成撤销体系认证资格；</p>
                                <p>（三）获证组织违反了认证证书及标志的使用规定，且在规定的时限内不能采取有效纠正措施；</p>
                                <p>（四）客户的获证管理体系持续地或严重地不满足认证要求，包括对管理体系有效性的要求；</p>
                                <p>（五）获证组织管理体系覆盖的产品出现重大不符合；</p>
                                <p>（六）获证组织在接受公司现场审核后六个月未交纳认证费用；</p>
                                <p>（七）获证组织未按规定的时限接受公司对其实施的监督审核或再认证审核，证书暂停；</p>
                                <p>（八）特定情况出现时不能接受公司对其实施提前监督审核或非例行审核；</p>
                                <p>（九）获证组织违反国家、地方、行业法律、法规及要求，国家、地方、行业抽查质量不合格；</p>
                                <p>（十）有充分信息表明该获证组织六个月以上体系不能有效运行；</p>
                                <p>（十一）获证客户主动请求暂停。</p>
                            </div>
                            <p style={paragraphStyle}>
                                审查部根据以上情况编制《获证组织认证注册资格变更通报表》，传递至技术评审部，经公司进行认证评定后，暂停获证组织认证注册资格，暂停期最长不超过6个月。技术评审部发出《认证结果通知书》通知获证组织并在网站公告。获证组织应按通知书要求执行。
                            </p>
                        </div>

                        {/* 五 恢复 */}
                        <div id="section5">
                            <div style={subTitleStyle}>五、 恢复</div>
                            <p style={paragraphStyle}>
                                获证组织被暂停认证注册资格后，应在暂停期满前一个月内提出书面申请，并提供实施有效的纠正措施的证据，经公司相关部门验证满足要求并经技术评审部评定通过后，恢复其认证注册资格，并发出《认证结果通知书》。
                            </p>
                        </div>

                        {/* 六 证书撤销 */}
                        <div id="section6">
                            <div style={subTitleStyle}>六、 证书撤销</div>
                            <p>有下列情况之一，撤销认证注册资格：</p>
                            <div style={listStyle}>
                                <p>（一）暂停认证资格通知书发出后，获证组织未按规定要求采取适当纠正措施；</p>
                                <p>（二）监督审核发现获证组织管理体系存在不符合项且在三个月内未采取有效纠正措施，且经认证评定会评定认为其严重程度已构成撤销其认证注册资格；</p>
                                <p>（三）暂停认证资格周期内，获证组织仍未能按公司要求接受监督审核，暂停期满后证书自动撤销；</p>
                                <p>（四）获证组织严重违反国家、地方、行业法律、法规及要求，发生严重的质量/环境/职业健康安全/食品安全事故等情况；</p>
                                <p>（五）发现其他构成撤销体系认证资格情况。</p>
                            </div>
                        </div>

                        {/* 七 证书注销 */}
                        <div id="section7">
                            <div style={subTitleStyle}>七、 证书注销</div>
                            <p>有下列情况之一注销认证注册资格：</p>
                            <div style={listStyle}>
                                <p>（一）由于认证要求和/或依据标准发生变更，获证组织不愿符合新要求；</p>
                                <p>（二）在认证证书有效期届满前三个月时，获证组织不愿向公司提出再认证申请；</p>
                                <p>（三）获证组织提出注销申请。</p>
                            </div>
                            <p style={paragraphStyle}>
                                审查部根据以上情况编制《获证组织认证注册资格变更通报表》，传递至技术评审部，经公司评定后，撤（注）销获证组织认证注册资格，技术评审部向获证组织发出《认证结果通知书》，收回认证证书及所有认证文件，并将其从公司认证企业名录中删除，在网站公告。
                            </p>
                        </div>

                        <div style={{height: '100px'}}></div> {/* 底部留白，方便滚动查看最后内容 */}

                    </div>

                </div>
            </div>

        </div>

    );
};

export default FifthPage;